// Copyright ©️ 2026 eVolve MEP, LLC

import { Button, TextInput, useMantineTheme } from '@mantine/core';
import type { UseFormReturnType } from '@mantine/form';

import type { SignInFormValues } from '../auth/useSignInSteps';

type Props = {
  form: UseFormReturnType<SignInFormValues>;
  busy: boolean;
};

/** The email input and Next button of the sign-in steps from `useSignInSteps`. */
export const EmailStepFields = ({ form, busy }: Props) => {
  const theme = useMantineTheme();
  return (
    <>
      <TextInput
        label="Email"
        name="email"
        data-cy="email-input"
        size="md"
        autoFocus
        type="email"
        disabled={busy}
        {...form.getInputProps('email')}
      />
      <Button type="submit" loading={busy} disabled={!form.isValid()} fullWidth color={`${theme.primaryColor}.9`}>
        Next
      </Button>
    </>
  );
};
